import { render, staticRenderFns } from "./check_standard_group_item.vue?vue&type=template&id=2a3ac75c&scoped=true&"
import script from "./check_standard_group_item.vue?vue&type=script&lang=js&"
export * from "./check_standard_group_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ac75c",
  null
  
)

export default component.exports